module.exports = __webpack_public_path__ + "static/media/grocery_breeze.59ee5a83.webp";